export default "__VITE_ASSET__DY_IIy1q__"